// extracted by mini-css-extract-plugin
export var subtitle = "_b5-2";
export var title = "_b5-0";
export var titleNoWrap = "_b5-1";